import { memo } from 'react';

// ============================================================================
// FUNDO DA ENTRADA — alinhado ao app por dentro (17/09/2026)
//
// O que havia antes: #030303 chapado, tres orbs de 500-600px com blur de 40px
// nas cores laranja, roxo e ciano, um vinheta radial, um spotlight e ruido.
// Sete camadas para dizer "premium".
//
// O problema nao era gosto, era incoerencia: o app por dentro e #121212 com
// UM acento, vindo do token --accent. Medido no dashboard: branco, #999 e o acento
// respondem por quase todo o texto da tela. Roxo e ciano nao existem em lugar
// nenhum depois do login. A porta estava pintada de um jeito que a casa nao e.
//
// Agora: o mesmo #121212 do app, com um unico halo laranja no topo — o
// suficiente para a tela nao ser um retangulo morto, e nada que compita com o
// conteudo. Uma camada animada, nao cinco.
// ============================================================================

export const PremiumBackground = memo(function PremiumBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Base: o mesmo tom do app, vindo do token, nao hardcoded */}
      <div className="absolute inset-0 bg-background" />

      {/* Halo do acento, entrando por cima. Fica atras do logo e morre antes de
          chegar nos controles, entao nunca disputa contraste com um botao.
          Ele girava em laco de 25 s (`animate-aurora-1`); parou em 20/09/2026.
          Era a unica coisa em movimento na tela de entrada, e movimento perpetuo
          atras de um formulario puxa o olho de quem esta tentando ler. */}
      <div
        className="absolute -top-[30%] left-1/2 -translate-x-1/2 w-[140%] max-w-[760px] aspect-square rounded-full"
        style={{
          background:
            'radial-gradient(circle, hsl(var(--accent) / 0.16) 0%, hsl(var(--accent) / 0.05) 45%, transparent 70%)',
          filter: 'blur(60px)',
        }}
      />

      {/* Assentamento: escurece o pe da tela para os botoes ficarem sobre um
          fundo estavel, independente do halo. */}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-background via-background/80 to-transparent" />
    </div>
  );
});
